export class TimeUtil {
    public static convertMillisecondsToMinutes(milliseconds: number): number {
        return milliseconds / 1000 / 60;
    }
}

